import Model from "./model";
import {TicketMessage} from './ticket-message.model';

export class Ticket extends Model {
  ticket_id: string = '';
  date_start: string = '';
  subscr_id: number = 0;
  messages: TicketMessage[] = [];
  description?: string;
  state_description: string = '';
  relation_id: number = 0;
  customer_can_reply: boolean = false;
  customer_read_at: Date | null = null
  unread_messages: number = 0;
  updated_at: Date = new Date();
}
